import * as Yup from 'yup';

export const changePasswordValidationSchema = Yup.object().shape({
    currentPassword: Yup.string().required('app.error.required'),
    newPassword: Yup.string().required('app.error.required').min(8, 'app.error.passwordComplexity'),
    newPasswordConfirmation: Yup.string()
        .required('app.error.required')
        .min(8, 'app.error.passwordComplexity')
        .oneOf([Yup.ref('newPassword'), null], 'app.error.passwordMatch'),
});
